module.exports = __webpack_public_path__ + "img/storage-pic.c9be576d.png";